import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAllVariantsAnalytics, getShopInfo, updateShopInfo } from "../../services/conditions.service";
import { RootState } from "../store";

const initialState = {
    loading: false,
    error: false,
    shopInfo: null,
} as any;

export const getShopInfoThunk = createAsyncThunk<any, void>(
  "shopinfo/getShopInfo",
  async () => {
    const shopInfo = await getShopInfo();

    return shopInfo;
  },
);

export const updateShopInfoThunk = createAsyncThunk<any, any>(
  "shopinfo/updateShopInfo",
  async (data) => {
    const response = await updateShopInfo(data);

    return response;
  },
);

const shopinfoSlice = createSlice({
  name: "shopinfo",
  initialState,
  reducers: {
    updateShopInfoLocal: (state, action) => {
      state.shopInfo = { ...state.shopInfo, ...action.payload };
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getShopInfoThunk.pending, state => {
        state.loading = true;
        state.error = false;
      })
      .addCase(getShopInfoThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.shopInfo = action.payload;
        state.error = false;
      })
      .addCase(getShopInfoThunk.rejected, (state, action) => {
        console.error("while fetching shop info", action.error.message);
        state.loading = false;
        state.error = true;
      })
      .addCase(updateShopInfoThunk.pending, state => {
        state.loading = true;
        state.error = false;
      })
      .addCase(updateShopInfoThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.shopInfo = { ...state.shopInfo, ...action.payload };
        state.error = false;
      })
      .addCase(updateShopInfoThunk.rejected, (state, action) => {
        console.error("while updating shop info", action.error.message);
        state.loading = false;
        state.error = true;
      });
  },
});

export const { updateShopInfoLocal } = shopinfoSlice.actions;

export default shopinfoSlice.reducer;
